import EntityFinderTabBase from "./EntityFinderTabBase.jsx";
import {STORE_KEYS} from "../../../other/constants/StoreKeys.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";

export default class EntityFinderClientTab extends EntityFinderTabBase {

  static get $name() {
    return "EntityFinderClientTab";
  }

  static get type() {
    return "entityfinderclienttab";
  }

  static get configurable() {
    return super.getTabWidget("Clients", { type: WIDGET_KEYS.columnEntityMainName, text: "Client", field: "name" });
  }

  onOpenEntityEditor({ record }) {
    this.editorHandler.openEditor(EDITOR_KEYS.clientEditorV2, record, {client: record });
  }

  get storeKey() {
    return STORE_KEYS.clientStore;
  }
}
EntityFinderClientTab.initClass();
